import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const SpotlightIcon = ({ color = '#fff', size = '15', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color}>
      <path d="M27.562 3.522a1.095 1.095 0 0 0-.95-.139L23.39 4.41l1.073-3.081a.973.973 0 0 0-.145-.91A1.07 1.07 0 0 0 23.463 0H9.537c-.34 0-.658.156-.856.42a.973.973 0 0 0-.145.909L9.609 4.41 6.39 3.383a1.095 1.095 0 0 0-.95.139.996.996 0 0 0-.44.818v13.325c0 .324.163.629.438.818a1.087 1.087 0 0 0 .95.14l3.222-1.028-1.074 3.082a.973.973 0 0 0 .145.909c.198.263.517.42.856.42h5.908v3.568l-4.913 4.702a.979.979 0 0 0 0 1.427c.206.197.476.296.746.296s.54-.099.746-.296l3.421-3.273v2.56c0 .557.473 1.009 1.055 1.009.583 0 1.055-.452 1.055-1.01v-2.56l3.422 3.274c.206.197.476.296.746.296s.54-.099.746-.296a.979.979 0 0 0 0-1.427l-4.914-4.701v-3.57h5.908c.34 0 .658-.156.856-.419a.973.973 0 0 0 .145-.91l-1.073-3.08 3.22 1.026a1.099 1.099 0 0 0 .95-.139.996.996 0 0 0 .439-.819V4.341a.996.996 0 0 0-.438-.82zM16.5 18.372c-4.247 0-7.702-3.305-7.702-7.369 0-4.063 3.455-7.369 7.702-7.369s7.702 3.306 7.702 7.37c0 4.063-3.455 7.368-7.702 7.368z" />
      <path d="M16.5 5.647c-3.17 0-5.75 2.533-5.75 5.647 0 3.114 2.58 5.647 5.75 5.647s5.75-2.533 5.75-5.647c0-3.114-2.58-5.647-5.75-5.647z" />
    </g>
  </svg>
);

SpotlightIcon.propTypes = propTypes;

export default SpotlightIcon;
